import React from 'react';

const Gas = () => {
  return <div style={{ padding: 8 }}>Топливо доступно только в платной версии.</div>;
};

export default Gas;
